export default __webpack_public_path__ + "static/media/POOJA_PATIL.503175e2.JPG";